import React from "react";
import { Link } from "react-router-dom";
import "../../style/hub.css";
import { BadukIcon, BlogIcon, GameIcon } from "./icons";

export default function Hub() {
  return (
    <div className="hub-page">
      <div className="hub-buttons">
        <Link to="/game" className="hub-square-button hub-square-button--game">
          <GameIcon />
          <span className="hub-label">게임</span>
        </Link>
        {/* /go는 choco-proxy가 다른 컨테이너로 라우팅하는 경로라 풀 페이지 이동 필요 */}
        <a href="/go" className="hub-square-button hub-square-button--baduk">
          <BadukIcon />
          <span className="hub-label">바둑</span>
        </a>
        <Link to="/blog" className="hub-square-button hub-square-button--blog">
          <BlogIcon />
          <span className="hub-label">블로그</span>
        </Link>
      </div>
    </div>
  );
}
